import { useTranslation } from 'react-i18next';
import { CountyFilter } from '../../../../models/Filters';
import { resources } from '../../../../resources/resources';
import { CheckboxFilter } from '../Common/CheckboxFilter';
import { mapToCountyFilterItems } from '../helpers';

interface AvailableInFilterProps {
  availabelInList: CountyFilter[];
  prevSelectedCountyIds: number[];
  handleAvailableInFilterChanged: (countyIds: number[]) => void;
}

export default function AvailableInFilter(
  props: Readonly<AvailableInFilterProps>,
) {
  const { t: translate } = useTranslation();
  const {
    availabelInList,
    prevSelectedCountyIds,
    handleAvailableInFilterChanged,
  } = props;

  return (
    <CheckboxFilter
      title={translate(resources.filters.availableInTitle)}
      filterItems={mapToCountyFilterItems(
        availabelInList,
        prevSelectedCountyIds,
      )}
      handleOnClick={handleAvailableInFilterChanged}
    />
  );
}
